export interface ClientAppConfig {
  app: {
    name: string;
    basePath: string;
  };
  api: {
    baseUrl: string;
  };
  dataConduit: {
    baseUrl: string;
  };
  maps: {
    mapboxToken: string;
    esriApiKey: string;
  };
  features: {
    agGridLicenseKey: string;
  };
}

export type AppConfig = ClientAppConfig;

export function shouldUseGoogleSecretsManager(): boolean {
  return process.env.USE_GOOGLE_SECRETS_MANAGER !== 'false';
}

function getEnvValue(key: string, required = false): string {
  const value = process.env[key];

  if (required && !value && shouldUseGoogleSecretsManager()) {
    throw new Error(`Required secret ${key} not loaded from Google Secrets Manager`);
  }

  return value || '';
}

export function getAuthConfig() {
  return {
    keycloak: {
      issuerUrl: process.env.KEYCLOAK_ISSUER_URL || '',
      clientId: process.env.KEYCLOAK_CLIENT_ID || '',
      clientSecret: getEnvValue('KEYCLOAK_CLIENT_SECRET', true),
    },
    nextAuth: {
      url: process.env.NEXTAUTH_URL || '',
      secret: getEnvValue('NEXTAUTH_SECRET', true),
    },
    nodeEnv: process.env.NODE_ENV || 'development',
  };
}

export function getClientConfig(): ClientAppConfig {
  if (!process.env.API_URL) {
    throw new Error('Missing required environment variable: API_URL');
  }

  return {
    app: {
      name: process.env.APP_NAME || 'assetCAST',
      basePath: process.env.BASE_PATH || '/assetcast',
    },
    api: {
      baseUrl: process.env.API_URL,
    },
    dataConduit: {
      baseUrl: process.env.DATA_CONDUIT_URL || 'http://localhost:3001',
    },
    maps: {
      mapboxToken: getEnvValue('MAPBOX_ACCESS_TOKEN', true),
      esriApiKey: getEnvValue('ESRI_API_KEY', true),
    },
    features: {
      agGridLicenseKey: getEnvValue('AGGRID_LICENSE_KEY', true),
    },
  };
}

export function getAppConfig(): AppConfig {
  return getClientConfig();
}

export const isDevelopment = () => process.env.NODE_ENV === 'development';
export const isProduction = () => process.env.NODE_ENV === 'production';
export const isTest = () => process.env.NODE_ENV === 'test';
